<template>
  <div>
    <!-- <h1>Map</h1> -->
    <!-- <p v&#45;for="(tutor, index) in tutors" :key="index">{{ tutor }}</p> -->
    <!-- <p v&#45;for="(marker, index) in markers" :key="index">{{ marker }}</p> -->
    <map-loader
      :map-config="mapConfig"
      apiKey="AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA"
    >
      <template v-for="marker in markers">
        <child-marker :position="marker.position" :key="marker.id"/>
      </template>
      <!-- <template v&#45;for="tutor in tutors"> -->
      <!--   <child&#45;marker :position="tutor.position" :key="tutor.id"/> -->
      <!-- </template> -->
    </map-loader>
  </div>
</template>

<script>
import MapLoader from '@/components/util/MapLoader.vue'
import ChildMarker from '@/components/util/ChildMarker'

export default {
  // inject: ['google', 'map'],
  props: {
    markers: Array,
    tutors: Array
  },
  data () {
    return {
      mapConfig: {
        zoom: 15,
        center: this.markers[0].position
      }
      // marker: null
    }
  },
  components: {
    MapLoader,
    ChildMarker
  },
  mounted () {
    // var DS = new this.google.maps.DirectionsService()
    // var DR = new this.google.maps.DirectionsRenderer()
    // DR.setMap(this.map)
    //
    // var request = {
    //   origin: this.markers[0].position,
    //   destination: this.markers[1].position,
    //   travelMode: this.google.maps.TravelMode.WALKING
    // }
    // DS.route(request, function (result, status) {
    //   DR.setDirections(result)
    // })
    //
    // const { Marker } = this.google.maps
    // this.marker = new Marker({
    //   position: this.markers[0].position,
    //   map: this.map,
    //   title: 'Child marker!'
    // })
  }
}
</script>



// WEBPACK FOOTER //
// MyMap.vue?ac755f5a